import { createRuntimeFn } from '@vanilla-extract/recipes/createRuntimeFn';

var tooltipContent = createRuntimeFn({defaultClassName:'fx_e395032e_ru7qad3',variantClassNames:{prefersReducedMotion:{noPreference:'fx_e395032e_ru7qad4',reduce:'fx_e395032e_ru7qad5'}},defaultVariants:{prefersReducedMotion:'noPreference'},compoundVariants:[]});
var tooltipContentBackground = 'var(--fx_e395032e_ru7qad2)';

export { tooltipContent, tooltipContentBackground };
//# sourceMappingURL=content.vanilla.mjs.map
